export default __webpack_public_path__ + "static/media/appbase.2f5fad5d.svg";